import { createBrowserHistory, History } from 'history'
import env from '@shared/env'

const history = createBrowserHistory({ basename: env.appBaseName })

export default history as NonNullable<History>
